export const ALL_UPDATE = 'UNIVERSEBUILDER/ALL/UPDATE';
export const GENERIC_UPDATE = 'UNIVERSEBUILDER/GENERIC/UPDATE';
export const UNIVERSE_BUILDER_FILTERGROUP_CREATE = 'UNIVERSEBUILDER/FILTERGROUP/CREATE';
export const UNIVERSE_BUILDER_UNIVERSE_SELECT = 'UNIVERSEBUILDER/UNIVERSE/SELECT';
export const UNIVERSE_BUILDER_FILTERGROUP_UPDATEDATA = 'UNIVERSEBUILDER/FILTERGROUP/UPDATEDATA';
export const RESET = 'UNIVERSEBUILDER/RESET';
